export const services = [
  {
    id: 1,
    name: 'General Service',
    description: 'Complete bike maintenance and checkup',
    price: 299,
    duration: '2 hours',
    includes: [
      'Engine oil change',
      'Chain cleaning and lubrication',
      'Brake adjustment',
      'Tire pressure check',
      'Battery check',
      'Light inspection'
    ],
    category: 'Maintenance'
  },
  {
    id: 2,
    name: 'Engine Repair',
    description: 'Complete engine diagnosis and repair',
    price: 1999,
    duration: '4-6 hours',
    includes: [
      'Engine diagnosis',
      'Carburetor cleaning',
      'Valve adjustment',
      'Piston ring replacement',
      'Gasket replacement',
      '6 month warranty'
    ],
    category: 'Repair'
  },
  {
    id: 3,
    name: 'Brake Service',
    description: 'Complete brake system service',
    price: 599,
    duration: '1 hour',
    includes: [
      'Brake pad inspection',
      'Brake fluid change',
      'Brake cable adjustment',
      'Disc cleaning',
      'Performance testing'
    ],
    category: 'Safety'
  }
];
